import { Link } from "react-router-dom";
import stylesE from "../../../layout/admin/Error.module.scss";
import ScreenTitle from "../../../layout/admin/ScreenTitle";
import SubScreenTitle from "../../../layout/admin/SubScreenTitle";

const ErrorAPIAdmin = () => {
  return (
    <div className={stylesE.main}>
      <ScreenTitle>システムエラー</ScreenTitle>
      <SubScreenTitle>エラーが発生しました</SubScreenTitle>
      <label>
        「渋谷生涯活躍ネットワーク・シブカツ(通称：シブカツ)」サイトにアクセスしていただきありがとうございます。
        <br></br>
        大変申し訳ございませんが、時間を置いて再度実行するか、管理者にお問合せ下さい。
      </label>
      <div>
        <Link to="../top">トップページ</Link>
      </div>
    </div>
  );
};

export default ErrorAPIAdmin;
